var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 15.0625C7.59812 15.0625 8.4375 15.9019 8.4375 16.9375C8.4375 17.9731 7.59812 18.8125 6.5625 18.8125C5.52688 18.8125 4.6875 17.9731 4.6875 16.9375C4.6875 15.9019 5.52688 15.0625 6.5625 15.0625Z",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 9.4375C13.2231 9.4375 14.0625 10.2769 14.0625 11.3125C14.0625 12.3481 13.2231 13.1875 12.1875 13.1875C11.1519 13.1875 10.3125 12.3481 10.3125 11.3125C10.3125 10.2769 11.1519 9.4375 12.1875 9.4375Z",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 18.8125C18.8481 18.8125 19.6875 19.6519 19.6875 20.6875C19.6875 21.7231 18.8481 22.5625 17.8125 22.5625C16.7769 22.5625 15.9375 21.7231 15.9375 20.6875C15.9375 19.6519 16.7769 18.8125 17.8125 18.8125Z",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 13.1875C24.4731 13.1875 25.3125 14.0269 25.3125 15.0625C25.3125 16.0981 24.4731 16.9375 23.4375 16.9375C22.4019 16.9375 21.5625 16.0981 21.5625 15.0625C21.5625 14.0269 22.4019 13.1875 23.4375 13.1875Z",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 31.25C14.9309 31.25 14.875 31.3059 14.875 31.375C14.875 31.4441 14.9309 31.5 15 31.5C15.0691 31.5 15.125 31.4441 15.125 31.375C15.125 31.3059 15.0691 31.25 15 31.25Z",
    fill: "#243656",
    stroke: "#C70048",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 31.375H2.8125C1.77688 31.375 0.9375 30.5356 0.9375 29.5V2.5C0.9375 1.46438 1.77688 0.625 2.8125 0.625H27.1875C28.2231 0.625 29.0625 1.46438 29.0625 2.5V29.5C29.0625 30.5356 28.2231 31.375 27.1875 31.375H17.8125",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.a182f1ef685d1e349036f8db6570875e.svg";
export { ForwardRef as ReactComponent };